<template>
  <div class="app-container">

    <el-button
        size="small"
        type="primary"
        class="go-back"
        @click.stop="goBack()"
    >
      返回
    </el-button>
    <el-tabs v-model="activeIndex" ref="tabs" type="border-card">
      <el-tab-pane label="群组信息" name="0">
        <group-info :forum-group-i-d="ForumGroupID" :part="part" :title="title"
                    :judge-creator="judgeCreator"></group-info>
      </el-tab-pane>
      <el-tab-pane label="群组文件" name="1">
        <group-files :forum-group-i-d="ForumGroupID"></group-files>
      </el-tab-pane>
    </el-tabs>
  </div>

</template>

<script>

import groupInfo from "@/views/mai/ultrasonic/ultrasonicGroupsDetail/ultrasonicGroupInfo";
import groupFiles from "@/views/mai/ultrasonic/ultrasonicGroupsDetail/ultrasonicGroupFiles";

export default {
  name: "ultrasonicGroupInfo",
  components: {
    groupInfo,
    groupFiles
  },
  methods: {
    goBack() {
      this.$router.replace({
        name: "forum_page",
        params: {
          part: this.part,
          groupType:this.$route.query.groupType,
          userDataType:this.$route.query.userDataType,
          searchValue:this.$route.query.searchValue,
          currentPage:this.$route.query.currentPage
        }
      })
    }
  },
  created() {
    this.ForumGroupID = this.$route.query.ForumGroupID;
    this.part = this.$route.query.part;
    this.title = this.$route.query.row;
    this.judgeCreator = this.$route.query.judgeCreator;
  },
  data() {
    return {
      ForumGroupID: -1,
      part: null,
      title: "",
      judgeCreator: false,
      activeIndex:"0",
    }
  }
}
</script>

<style scoped>

</style>